import { type LocationListingQuery } from 'cms/cms';
import { resolveImageReferenceToImage } from './imageResolver';
import type { ContentModelReference } from 'cms/cms-types';
import { type LocationMapItem } from '4-sections/FilteredListings/MapAndListing/Map/ListingMap';
import { generateDescription, type LocationCardResolverSettings } from './locationCardResolver';


export type LocationPage = NonNullable<LocationListingQuery['LocationPage']>;
export type LocationPageItems = NonNullable<LocationPage['items']>;

export const resolveLocationPagesToMapItems = (items: LocationPageItems, settings: LocationCardResolverSettings): LocationMapItem[] => {
    return items.map(item => {
        // // the autogenerated produce | null for each item, need to remove the | null type
        const {
            ContentLink,
            Title,
            PreviewTitle,
            Address,
            PhoneNumber,
            EmailAddress,
            PreviewImage,
            Latitude,
            Longitude,
            // Countries
        } = item as NonNullable<typeof item>;
        const { emailLabel, telLabel } = settings;
        const id = String((ContentLink as NonNullable<typeof ContentLink>).Id);
        const imgSrcSets = [480, 767];
        const img = resolveImageReferenceToImage(PreviewImage as ContentModelReference, '?width=340', imgSrcSets);

        const coordinates = {
            lat: Number(Latitude),
            lon: Number(Longitude),
        };

        const description = generateDescription({ Address, EmailAddress, PhoneNumber, emailLabel, telLabel });

        return {
            id,
            name: PreviewTitle || Title as string,
            description,
            ...(img && { img }),
            coordinates,
            href: ContentLink?.Url ? ContentLink.Url : '',
        };
    });
};
